import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './news.loaders';
import { newsKeys } from './news.queries';

export const useCreateNew = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.createNew, {
    onSuccess: () => {
      return queryClient.invalidateQueries(newsKeys.lists);
    },
  });

  return mutation;
};

export const useUpdateNew = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.updateNew, {
    onSuccess: () => {
      return queryClient.invalidateQueries(newsKeys.all);
    },
  });

  return mutation;
};

export const useCopyNew = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.copyNew, {
    onSuccess: () => {
      return queryClient.invalidateQueries(newsKeys.lists);
    },
  });

  return mutation;
};

export const useRemoveNew = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.deleteNew, {
    onSuccess: () => {
      return queryClient.invalidateQueries(newsKeys.lists);
    },
  });

  return mutation;
};

export const useExportToXls = () => {
  const mutation = useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });

  return mutation;
};

export const useCreateNewsCategory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.createCategory, {
    onSuccess: () => {
      return queryClient.invalidateQueries(newsKeys.list('categories'));
    },
  });

  return mutation;
};

export const useUpdateNewsCategory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.updateCategory, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(newsKeys.detail('categories')),
        queryClient.invalidateQueries(newsKeys.list('categories')),
      ]);
    },
  });

  return mutation;
};

export const useRemoveNewsCategory = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(loaders.deleteCategory, {
    onSuccess: () => {
      return queryClient.invalidateQueries(newsKeys.list('categories'));
    },
  });

  return mutation;
};
